<template lang="html">
    <div class="single-information mt-3 text-xs-center">
        <v-flex xs12>
            <single-card class="general-infos">
                <template slot="content">
                    <v-layout>
                        <v-flex xs12>
                            <div class="subtitle"> Changer le mot de passe </div>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12>
                            <v-btn
                              color="primary"
                              round
                              outline
                              @click="$eventHub.$emit('open-modal', ResetPassword)"
                              class="mt-4"
                              :disabled="$store.state.auth.user.level < 60 && $store.state.auth.user.id != $store.state.single.data.id"
                            >
                              Reinitialiser le mot de passe
                              <v-icon right>vpn_key</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </template>
            </single-card>
        </v-flex>
    </div>
</template>

<script>
    import SingleCard   	from '../../../../components/single/SingleCard.vue'
    import SingleField		from '../../../../components/SingleField.vue'
    import ResetPassword    from './ResetPassword.vue'


    export default {
        components: { SingleCard , SingleField },

        data() {
            return {
                ResetPassword
            }
        },

        computed: {
            data() { return this.$store.state.single.data }
        },

        methods: {
            updateField(key, value, resource = 'users') {
                let model	= {};
                model[key] 	= value;

                this.axios.put(`/api/${resource}/${this.$route.params.id}`, model)
                    .then(res   => this.$store.dispatch('updateSingleData', { key, value }))
                    .catch(err  => this.$refs[key].setError(error.response.data.errors[key][0]))
            },
        }
    }
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/users/single/General.vue